import { useState } from 'react'
import { ICreateShipmentInput, IError } from 'types/graphqlTypes'
import { useCreateShipmentMutation } from '../graphql/CreateShipment'
import { TCreateShipmentSchema } from '../schema'
import { getCreateShipmentMutationInput } from '../utils'

export interface ICreateShipmentMutationResult {
  shipmentId: string | undefined
}

export interface IUseCreateShipmentState {
  createShipment: (formValues: TCreateShipmentSchema) => Promise<ICreateShipmentMutationResult>
  errors: IError[]
  loading: boolean
}

const useCreateShipment = (): IUseCreateShipmentState => {
  const [errors, setErrors] = useState<IError[]>([])
  const [createShipmentMutation, { loading }] = useCreateShipmentMutation()

  const createShipment = async (
    formValues: TCreateShipmentSchema
  ): Promise<ICreateShipmentMutationResult> => {
    const input: ICreateShipmentInput = getCreateShipmentMutationInput(formValues)
    try {
      const { data } = await createShipmentMutation({
        variables: { input },
      })

      const { createShipment: createShipmentData } = data || {}
      const { errors: mutationErrors, shipment } = createShipmentData || {}
      const { id } = shipment || {}

      if (mutationErrors) {
        setErrors(mutationErrors)
      }

      return {
        shipmentId: id,
      }
    } catch {
      setErrors([{ key: 'form-error', message: 'There was an error creating this shipment' }])

      return {
        shipmentId: undefined,
      }
    }
  }

  return {
    createShipment,
    errors,
    loading,
  }
}

export default useCreateShipment
